// extracted by mini-css-extract-plugin
export default {"container":"TwoColumnLayout_container__S1MZo","left":"TwoColumnLayout_left__BDW5e","right":"TwoColumnLayout_right__rig4w"};